import styled from "styled-components";

export const MapContainer = styled.div`
    width: min(92%, 1200px);
    margin: 60px auto 0;
`;

export const MapWrapper = styled.div`
    display: flex;
    justify-content: center;
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--shadow-md);

    iframe {
        border: none;
        width: 100%;
        max-width: 1100px;
        height: 450px;
        display: block;

        @media (max-width: 768px) {
            height: 360px;
        }

        @media (max-width: 480px) {
            height: 300px;
        }
    }
`;

export const MapText = styled.p`
    font-size: 18px;
    text-align: center;
    color: var(--color-primary);
    font-weight: 600;
    margin-top: 24px;
`;
